import { SupportQuality } from '../../core/models/supports/support-quality.model';
import { SupportType } from '../../core/models/supports/support-type-enum';

export class SupportsUtils {
  public static isTicket(support: SupportType): boolean {
    return support === SupportType.TICKET;
  }

  public static isPallet(support: SupportType): boolean {
    return support !== SupportType.TICKET;
  }

  public static isBroken(supportQualityValue: string): boolean {
    return supportQualityValue === SupportQuality.BROKEN;
  }

  public static isExchangeable(support: SupportType, supportQuality: SupportQuality) {
    return (support === SupportType.PALLET || support === SupportType.TICKET)
        && supportQuality !== SupportQuality.BROKEN;
  }

  public static isExchangeableQuality(supportQuality: SupportQuality) {
    return supportQuality !== SupportQuality.BROKEN && supportQuality !== SupportQuality.USED;
  }

  public static setSupports(palletOnly: boolean, ticketOnly: boolean, exchangeableOnly: boolean): SupportType[] {
    if (palletOnly) {
      return [
        SupportType.PALLET,
        SupportType.PALLET_LIGHT_80_120,
        SupportType.PALLET_LIGHT_100_120,
        SupportType.PALLET_LIGHT_60_100,
        SupportType.PALLET_LIGHT_60_80,
        SupportType.PALLET_HALF_80_120,
        SupportType.PALLET_DOSS_100_120,
        SupportType.PALLET_DOSS_METAL_100_120,
        SupportType.HALF_PALLET_60_80,
        SupportType.HALF_PALLET_SOLE_60_80,
        SupportType.BOX_MEAT_60_40_20,
        SupportType.CONTAINER_EUR,
        SupportType.PALLET_PLASTIC_120_120,
        SupportType.BLUE_BOX,
        SupportType.RED_BOX,
        SupportType.BASE,
        SupportType.FIL,
        SupportType.PLASTIC_PALLET,
        SupportType.HALF_PLASTIC_PALLET,
        SupportType.BUTCHER_ROLL,
        SupportType.COVER
      ];
    } else if (ticketOnly) {
      return [SupportType.TICKET];
    } else if (exchangeableOnly) {
      return [
        SupportType.PALLET,
        SupportType.TICKET
      ];
    } else {
      return [
        SupportType.PALLET,
        SupportType.PALLET_LIGHT_80_120,
        SupportType.PALLET_LIGHT_100_120,
        SupportType.PALLET_LIGHT_60_100,
        SupportType.PALLET_LIGHT_60_80,
        SupportType.PALLET_HALF_80_120,
        SupportType.PALLET_DOSS_100_120,
        SupportType.PALLET_DOSS_METAL_100_120,
        SupportType.HALF_PALLET_60_80,
        SupportType.HALF_PALLET_SOLE_60_80,
        SupportType.BOX_MEAT_60_40_20,
        SupportType.CONTAINER_EUR,
        SupportType.PALLET_PLASTIC_120_120,
        SupportType.BLUE_BOX,
        SupportType.RED_BOX,
        SupportType.BASE,
        SupportType.FIL,
        SupportType.PLASTIC_PALLET,
        SupportType.HALF_PLASTIC_PALLET,
        SupportType.BUTCHER_ROLL,
        SupportType.COVER,
        SupportType.TICKET
      ];
    }
  }

  public static readonly labelSupportTypeSing: { [key: string]: string } = {
    PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET',
    PALLET_LIGHT_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_80_120',
    PALLET_LIGHT_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_100_120',
    PALLET_LIGHT_60_100: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_60_100',
    PALLET_LIGHT_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_60_80',
    PALLET_HALF_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_HALF_80_120',
    PALLET_DOSS_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_DOSS_100_120',
    PALLET_DOSS_METAL_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_DOSS_METAL_100_120',
    HALF_PALLET_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PALLET_60_80',
    HALF_PALLET_SOLE_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PALLET_SOLE_60_80',
    BOX_MEAT_60_40_20: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BOX_MEAT_60_40_20',
    CONTAINER_EUR: 'MANAGEMENT.STOCKS.SUPPORTS_SING.CONTAINER_EUR',
    PALLET_PLASTIC_120_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_PLASTIC_120_120',
    BLUE_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BLUE_BOX',
    RED_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_SING.RED_BOX',
    BASE: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BASE',
    FIL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.FIL',
    PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PLASTIC_PALLET',
    HALF_PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PLASTIC_PALLET',
    BUTCHER_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BUTCHER_ROLL',
    COVER: 'MANAGEMENT.STOCKS.SUPPORTS_SING.COVER',
    TICKET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.TICKET',
    ALL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.ALL'
  };

  public static readonly labelAllSupportTypeSing: { [key: string]: string } = {
    PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET',
    PALLET_LIGHT_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_80_120',
    PALLET_LIGHT_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_100_120',
    PALLET_LIGHT_60_100: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_60_100',
    PALLET_LIGHT_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_LIGHT_60_80',
    PALLET_HALF_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_HALF_80_120',
    PALLET_DOSS_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_DOSS_100_120',
    PALLET_DOSS_METAL_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_DOSS_METAL_100_120',
    HALF_PALLET_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PALLET_60_80',
    HALF_PALLET_SOLE_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PALLET_SOLE_60_80',
    BOX_MEAT_60_40_20: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BOX_MEAT_60_40_20',
    CONTAINER_EUR: 'MANAGEMENT.STOCKS.SUPPORTS_SING.CONTAINER_EUR',
    UNIT_CARDBOARD_WASTE: 'MANAGEMENT.STOCKS.SUPPORTS_SING.UNIT_CARDBOARD_WASTE',
    UNIT_PLASTIC_WASTE: 'MANAGEMENT.STOCKS.SUPPORTS_SING.UNIT_PLASTIC_WASTE',
    UNIT_PET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.UNIT_PET',
    PLASTIC_BELT: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PLASTIC_BELT',
    BOX_IFCO: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BOX_IFCO',
    CC_TAG5_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.CC_TAG5_ROLL',
    CC_PLATE_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.CC_PLATE_ROLL',
    DC_ROLL_OTHER: 'MANAGEMENT.STOCKS.SUPPORTS_SING.DC_ROLL_OTHER',
    CC_SHELF: 'MANAGEMENT.STOCKS.SUPPORTS_SING.CC_SHELF',
    NON_CC_SHELF: 'MANAGEMENT.STOCKS.SUPPORTS_SING.NON_CC_SHELF',
    ROLLS_SUPPORT: 'MANAGEMENT.STOCKS.SUPPORTS_SING.ROLLS_SUPPORT',
    LARGE_METALLIC_RISER: 'MANAGEMENT.STOCKS.SUPPORTS_SING.LARGE_METALLIC_RISER',
    SMALL_METALLIC_RISER: 'MANAGEMENT.STOCKS.SUPPORTS_SING.SMALL_METALLIC_RISER',
    FLORISTRY_BUCKETS_SIZE_1_SQUARE: 'MANAGEMENT.STOCKS.SUPPORTS_SING.FLORISTRY_BUCKETS_SIZE_1_SQUARE',
    FLORISTRY_BUCKETS_SIZE_2_ROUND: 'MANAGEMENT.STOCKS.SUPPORTS_SING.FLORISTRY_BUCKETS_SIZE_2_ROUND',
    PALLET_PLASTIC_120_120: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PALLET_PLASTIC_120_120',
    BLUE_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BLUE_BOX',
    RED_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_SING.RED_BOX',
    BASE: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BASE',
    FIL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.FIL',
    PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.PLASTIC_PALLET',
    HALF_PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.HALF_PLASTIC_PALLET',
    BUTCHER_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.BUTCHER_ROLL',
    COVER: 'MANAGEMENT.STOCKS.SUPPORTS_SING.COVER',
    TICKET: 'MANAGEMENT.STOCKS.SUPPORTS_SING.TICKET',
    ALL: 'MANAGEMENT.STOCKS.SUPPORTS_SING.ALL'
  };

  public static readonly labelSupportQualitySing: { [key: string]: string } = {
    NEW: 'MANAGEMENT.STOCKS.QUALITY_SING.NEW',
    FIRST_CHOICE: 'MANAGEMENT.STOCKS.QUALITY_SING.FIRST_CHOICE',
    SECOND_CHOICE: 'MANAGEMENT.STOCKS.QUALITY_SING.SECOND_CHOICE',
    SECOND_CHOICE_NON_MECHANIZABLE: 'MANAGEMENT.STOCKS.QUALITY_SING.SECOND_CHOICE_NON_MECHANIZABLE',
    USED: 'MANAGEMENT.STOCKS.QUALITY_SING.USED',
    ALL_INCOMER: 'MANAGEMENT.STOCKS.QUALITY_SING.ALL_INCOMER',
    BROKEN: 'MANAGEMENT.STOCKS.QUALITY_SING.BROKEN'
  };

  public static readonly labelSupportQualityPlural: { [key: string]: string } = {
    NEW: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.NEW',
    FIRST_CHOICE: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.FIRST_CHOICE',
    SECOND_CHOICE: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.SECOND_CHOICE',
    SECOND_CHOICE_NON_MECHANIZABLE: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.SECOND_CHOICE_NON_MECHANIZABLE',
    USED: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.USED',
    ALL_INCOMER: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.ALL_INCOMER',
    BROKEN: 'MANAGEMENT.STOCKS.QUALITY_PLURAL.BROKEN'
  };

  public static readonly labelSupportTypePlural: { [key: string]: string } = {
    PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET',
    PALLET_LIGHT_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_LIGHT_80_120',
    PALLET_LIGHT_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_LIGHT_100_120',
    PALLET_LIGHT_60_100: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_LIGHT_60_100',
    PALLET_LIGHT_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_LIGHT_60_80',
    PALLET_HALF_80_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_HALF_80_120',
    PALLET_DOSS_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_DOSS_100_120',
    PALLET_DOSS_METAL_100_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_DOSS_METAL_100_120',
    HALF_PALLET_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.HALF_PALLET_60_80',
    HALF_PALLET_SOLE_60_80: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.HALF_PALLET_SOLE_60_80',
    BOX_MEAT_60_40_20: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.BOX_MEAT_60_40_20',
    CONTAINER_EUR: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.CONTAINER_EUR',
    UNIT_CARDBOARD_WASTE: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.UNIT_CARDBOARD_WASTE',
    UNIT_PLASTIC_WASTE: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.UNIT_PLASTIC_WASTE',
    UNIT_PET: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.UNIT_PET',
    PLASTIC_BELT: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PLASTIC_BELT',
    BOX_IFCO: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.BOX_IFCO',
    CC_TAG5_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.CC_TAG5_ROLL',
    CC_PLATE_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.CC_PLATE_ROLL',
    DC_ROLL_OTHER: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.DC_ROLL_OTHER',
    CC_SHELF: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.CC_SHELF',
    NON_CC_SHELF: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.NON_CC_SHELF',
    ROLLS_SUPPORT: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.ROLLS_SUPPORT',
    LARGE_METALLIC_RISER: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.LARGE_METALLIC_RISER',
    SMALL_METALLIC_RISER: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.SMALL_METALLIC_RISER',
    FLORISTRY_BUCKETS_SIZE_1_SQUARE: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.FLORISTRY_BUCKETS_SIZE_1_SQUARE',
    FLORISTRY_BUCKETS_SIZE_2_ROUND: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.FLORISTRY_BUCKETS_SIZE_2_ROUND',
    PALLET_PLASTIC_120_120: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PALLET_PLASTIC_120_120',
    BLUE_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.BLUE_BOX',
    RED_BOX: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.RED_BOX',
    BASE: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.BASE',
    FIL: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.FIL',
    PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.PLASTIC_PALLET',
    HALF_PLASTIC_PALLET: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.HALF_PLASTIC_PALLET',
    BUTCHER_ROLL: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.BUTCHER_ROLL',
    COVER: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.COVER',
    TICKET: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.TICKET',
    ALL: 'MANAGEMENT.STOCKS.SUPPORTS_PLURAL.ALL'
  };

}
